// Manage Realms
import { manageDnc, manageDncConfig } from './manage.dnc.js'

export default function manageDncRoutes($stateProvider) {
  'ngInject'
  $stateProvider.state(manageDnc, manageDncConfig)
}
